/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-03 10:17:37
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getAdminTaskList
   * @description 批次任务列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getAdminTaskList(data) {
    return request.post(`${BASE_URL}/admin_task/list`, data)
  },
  /**
   * getAdminTaskInfo
   * @description 获取公司详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getAdminTaskInfo(data) {
    return request.post(`${BASE_URL}/admin_task/get_info`, data)
  },
  /**
   * deleteAdminTask
   * @description 删除任务
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteAdminTask(id) {
    let data = {id:id}
    return request.post(`${BASE_URL}/admin_task/delete`, data)
  },
  /**
   * auditAdminTask
   * @description 审核任务
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  auditAdminTask(data) {
    return request.post(`${BASE_URL}/admin_task/audit`, data)
  },
}